define([
    "./commonsCancellationModule",
    "./cancellationServiceInvoker",
    "./cancellationServiceUrl"
], function(){

});